import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Apollo} from 'apollo-angular';
import gql from 'graphql-tag';
import {GetUser, GetUser_me, GetUser_user, GetUserVariables} from './__generated__/GetUser';
import {RoleType, LanguageType} from '../../../shared/graphql/globalTypes';
import {catchError} from 'rxjs/operators';
import {EMPTY, Subscription} from 'rxjs';
import {ErrorService} from '../../../shared/services/error.service';
import {
  labelFrag,
  MultiSelectType,
} from '../../../shared/components/multi-select/multi-select.component';
import {MultiSelectComponentLabelFragment} from '../../../shared/components/multi-select/__generated__/MultiSelectComponentLabelFragment';
import {UntypedFormControl} from '@angular/forms';

const userGetQuery = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      function
      language
      phone
      photo
      role
      labels {
        edges {
          node {
            ...MultiSelectComponentLabelFragment
          }
        }
      }
    }
    me {
      id
      firstName
      lastName
      role
    }
    labels {
      edges {
        node {
          ...MultiSelectComponentLabelFragment
        }
      }
    }
  }
  ${labelFrag}
`;

@Component({
  selector: 'app-profile',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  standalone: false,
})
export class UserComponent implements OnInit, OnDestroy {
  user: GetUser_user | null = null;
  currentUser: GetUser_me | null = null;
  userIsCurrentUser = false;
  RoleType = RoleType;
  LanguageType = LanguageType;
  private subscriptions: Subscription[] = [];
  labels: MultiSelectComponentLabelFragment[] = [];
  MultiSelectType = MultiSelectType;
  userLabelControl = new UntypedFormControl({value: [], disabled: true});

  constructor(
    private router: Router,
    private apollo: Apollo,
    private route: ActivatedRoute,
    private errService: ErrorService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<GetUser, GetUserVariables>({
          query: userGetQuery,
          variables: {
            id: this.route.snapshot.params.id,
          },
        })
        .valueChanges.pipe(
          catchError(error => {
            this.errService.handleDefault(error);
            return EMPTY;
          }),
        )
        .subscribe(data => {
          this.user = data.data?.user ?? null;
          this.currentUser = data.data?.me ?? null;
          this.labels = (data.data?.labels.edges ?? []).map(edge => edge.node);
          if (this.user) {
            this.userLabelControl.setValue((this.user.labels.edges ?? []).map(edge => edge.node));
          }

          if (this.user !== null && this.currentUser !== null) {
            if (
              this.user.firstName + this.user.lastName ===
              this.currentUser.firstName + this.currentUser.lastName
            ) {
              this.userIsCurrentUser = true;
            }
          }
        }),
    );
  }

  navigateBack(): void {
    this.router.navigate(['users']);
  }

  toEditUser(): void {
    this.router.navigate(['edit-user', this.route.snapshot.params.id]);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
}
